import { BarCodeService } from "./core/barCodeService";
import { Dispatcher } from "./core/dispatcher";
import { ResourceManager } from "./core/resourceManager";
import { Security } from "./core/security";
import { SoundService } from "./core/soundService";
import { KEvent } from "./core/utils";
import { ICultureInfo } from "./abstraction/ICultureInfos";
import { ILogin } from "./abstraction/ILogin";

export const soundSvc: SoundService = new SoundService();
export const resourceManager: ResourceManager = new ResourceManager();
export const dispatcher: Dispatcher = new Dispatcher();
export const securitySvc: Security = new Security(dispatcher as ILogin);
export const barCodeSvc: BarCodeService = new BarCodeService();

class KarmaApp {
    constructor() {
        console.log("Karma App()");
    }


    // Initialisation principale
    public async Init() {
        console.log("Karma WMS- starting core process")

        //#region Initialisation Langues
        console.log("Language init")

        let lang = navigator.language;

        const value = "; " + document.cookie;
        const parts = value.split("; lang=");

        if (parts.length == 2) {
            lang = parts[1] 
        }

        lang = (lang + ";").split(';')[0];
        lang = await dispatcher.getX3LangCode(lang);

        console.log("Culture code set to : " + lang)

        this.currentCultureCode = lang;
        this.OnCultureChanged.trigger(lang);

        this.storeLang(lang);

        await this.fetchCultures();

        console.log ("End of culture init")
        //#endregion


        if (securitySvc.isAuth()) await securitySvc.RestoreSession()
    }

    private storeLang(lang: string) {
        // Set cookie (expires in 7 days)
        const date = new Date();
        date.setTime(date.getTime() + (7 * 24 * 60 * 60 * 1000));
        document.cookie = "lang=" + lang + "; expires=" + date.toUTCString() + "; path=/";
    }

    // Change la langue courante et charge les libellés correpondants
    public async setLang(lang: string) {
        console.log("setlang(" + lang + ")");
        this.currentCultureCode = lang;
        this.OnCultureChanged.trigger(lang);
        this.storeLang(lang);
    }

    // Récupération des cultures sur le serveur
    private async fetchCultures() {
        this.cultureInfos = await dispatcher.getCultureInfos();
    }

    // Contient toutes les cultures supportées par le client
    private cultureInfos: ICultureInfo[] = [];

    private currentCultureCode: string = "";

    public getCurrentCulture(): ICultureInfo {
        return this.getCultures().filter(x => x.code == this.currentCultureCode)[0];
    }

    public getCultures(): ICultureInfo[] {
        return this.cultureInfos;
    }

    public getActiveCultures(): ICultureInfo[] {
        return this.cultureInfos.filter(x => x.active == true);
    }

    public getCurrentCultureCode(): string {
        return this.currentCultureCode;
    }

    // Evènement indiquant un changement de langue
    private _OnCultureChanged: KEvent<string> = new KEvent<string>();
    public get OnCultureChanged(): KEvent<string> { return this._OnCultureChanged; }

	private _OnRefresh: KEvent<any> = new KEvent<any>();
	public get OnRefresh(): KEvent<any> { return this._OnRefresh; }


}

export const Karma: KarmaApp = new KarmaApp();